import type { LocalOnboardingStep } from '@/onboarding/types'

/** Compute onboarding step route name based on the step name */
export const getStepRouteName = (step: LocalOnboardingStep) => {
  return `fish-onboarding-${step}`
}
